<template lang="pug">
PublicEditalLayout
  .cadastro-aviso(v-loading="loading")
    CadastroPageHeader(
      :titulo="tituloPagina"
      :subtitulo="subtituloPagina"
    )

    .cadastro-aviso__card
      CadastroAlertInfo(
        :titulo="alerta.titulo"
        :descricao="alerta.descricao"
      )

      section.cadastro-aviso__section(v-if="documentosAviso.length")
        CadastroSectionLabel(label="Documentos necessários")
        .cadastro-aviso__lista
          CadastroRequisitoItem(
            v-for="(item, index) in documentosAviso"
            :key="`doc-${index}`"
            :titulo="item.titulo"
            :obrigatorio="item.obrigatorio"
            :descricao="item.descricao"
          )

      section.cadastro-aviso__section(v-if="informacoesAviso.length")
        CadastroSectionLabel(label="Informações necessárias")
        .cadastro-aviso__lista
          CadastroRequisitoItem(
            v-for="(item, index) in informacoesAviso"
            :key="`info-${index}`"
            :titulo="item.titulo"
            :obrigatorio="item.obrigatorio"
            :descricao="item.descricao"
          )

    CadastroPageActions(
      :mostrar-continuar="true"
      @cancelar="cancelar"
      @continuar="continuar"
    )

    CadastroConfirmDialog(
      :aberto="modalCancelarAberto"
      :titulo="$messages.TITULO_WARNING"
      :mensagem="$messages.CANCELAR_CADASTRO"
      @cancelar="fecharModalCancelar"
      @confirmar="confirmarCancelamento"
    )
</template>

<script>
import PublicEditalLayout from '@/components/editais/PublicEditalLayout'
import CadastroPageHeader from '@/components/cadastro/CadastroPageHeader'
import CadastroAlertInfo from '@/components/cadastro/CadastroAlertInfo'
import CadastroSectionLabel from '@/components/cadastro/CadastroSectionLabel'
import CadastroRequisitoItem from '@/components/cadastro/CadastroRequisitoItem'
import CadastroPageActions from '@/components/cadastro/CadastroPageActions'
import CadastroConfirmDialog from '@/components/cadastro/CadastroConfirmDialog'
import cadastroCredenciadoMixin from '@/screens/credenciados/cadastroCredenciadoMixin'
import {
  CADASTRO_ALERTA_AVISO,
  CADASTRO_AVISO_INFORMACOES,
  CADASTRO_SUBTITULOS,
  CADASTRO_TITULOS,
  getDocumentosAviso
} from '@/constants/cadastroPublico'

export default {
  name: 'CadastroCredenciadoAviso',
  components: {
    PublicEditalLayout,
    CadastroPageHeader,
    CadastroAlertInfo,
    CadastroSectionLabel,
    CadastroRequisitoItem,
    CadastroPageActions,
    CadastroConfirmDialog
  },
  mixins: [cadastroCredenciadoMixin],
  computed: {
    tituloPagina () {
      const tipo = CADASTRO_TITULOS[this.tipoCadastro] || 'credenciado'
      return `Cadastro de credenciado ${tipo}`
    },
    subtituloPagina () {
      return CADASTRO_SUBTITULOS.aviso
    },
    alerta () {
      return CADASTRO_ALERTA_AVISO
    },
    documentosAviso () {
      return getDocumentosAviso(this.tipoCadastro)
    },
    informacoesAviso () {
      return CADASTRO_AVISO_INFORMACOES
    }
  },
  async mounted () {
    await this.initCadastro()
  },
  methods: {
    continuar () {
      this.$router.push({
        name: 'credenciados/cadastro/formulario',
        params: { idEdital: this.idEdital }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-aviso__card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgba(20, 20, 20, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.cadastro-aviso__section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
}

.cadastro-aviso__lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
